__turbopack_export_value__({
  "body-logo-18": "ButtonArrow-module-scss-module__E5z8GW__body-logo-18",
  "body-text-12": "ButtonArrow-module-scss-module__E5z8GW__body-text-12",
  "body-text-14": "ButtonArrow-module-scss-module__E5z8GW__body-text-14",
  "body-text-16": "ButtonArrow-module-scss-module__E5z8GW__body-text-16",
  "body-text-18": "ButtonArrow-module-scss-module__E5z8GW__body-text-18",
  "body-text-20": "ButtonArrow-module-scss-module__E5z8GW__body-text-20",
  "body-text-24": "ButtonArrow-module-scss-module__E5z8GW__body-text-24",
  "body-text-24-2": "ButtonArrow-module-scss-module__E5z8GW__body-text-24-2",
  "body-text-heading-2": "ButtonArrow-module-scss-module__E5z8GW__body-text-heading-2",
  "body-text-heading-3": "ButtonArrow-module-scss-module__E5z8GW__body-text-heading-3",
  "body-text-medium-14": "ButtonArrow-module-scss-module__E5z8GW__body-text-medium-14",
  "body-text-medium-16": "ButtonArrow-module-scss-module__E5z8GW__body-text-medium-16",
  "body-text-medium-18": "ButtonArrow-module-scss-module__E5z8GW__body-text-medium-18",
  "body-text-medium2-18": "ButtonArrow-module-scss-module__E5z8GW__body-text-medium2-18",
  "body-text2-14": "ButtonArrow-module-scss-module__E5z8GW__body-text2-14",
  "body-text2-16": "ButtonArrow-module-scss-module__E5z8GW__body-text2-16",
  "button": "ButtonArrow-module-scss-module__E5z8GW__button",
  "button-primary-text": "ButtonArrow-module-scss-module__E5z8GW__button-primary-text",
  "button-text": "ButtonArrow-module-scss-module__E5z8GW__button-text",
  "button2-text": "ButtonArrow-module-scss-module__E5z8GW__button2-text",
  "button_reverse": "ButtonArrow-module-scss-module__E5z8GW__button_reverse",
  "button_transparent": "ButtonArrow-module-scss-module__E5z8GW__button_transparent",
  "card-shadow": "ButtonArrow-module-scss-module__E5z8GW__card-shadow",
  "effect-menu": "ButtonArrow-module-scss-module__E5z8GW__effect-menu",
  "header-1": "ButtonArrow-module-scss-module__E5z8GW__header-1",
  "main-container": "ButtonArrow-module-scss-module__E5z8GW__main-container",
  "main-footer-container": "ButtonArrow-module-scss-module__E5z8GW__main-footer-container",
  "main-header-container": "ButtonArrow-module-scss-module__E5z8GW__main-header-container",
  "txt-12-bold": "ButtonArrow-module-scss-module__E5z8GW__txt-12-bold",
  "txt-14-bold": "ButtonArrow-module-scss-module__E5z8GW__txt-14-bold",
  "txt-14-bold-caps": "ButtonArrow-module-scss-module__E5z8GW__txt-14-bold-caps",
  "txt-14-med": "ButtonArrow-module-scss-module__E5z8GW__txt-14-med",
  "txt-16-bold": "ButtonArrow-module-scss-module__E5z8GW__txt-16-bold",
  "txt-16-med": "ButtonArrow-module-scss-module__E5z8GW__txt-16-med",
  "txt-18-bold": "ButtonArrow-module-scss-module__E5z8GW__txt-18-bold",
  "txt-18-medium": "ButtonArrow-module-scss-module__E5z8GW__txt-18-medium",
  "txt-18-medium-24": "ButtonArrow-module-scss-module__E5z8GW__txt-18-medium-24",
  "txt-24-semi": "ButtonArrow-module-scss-module__E5z8GW__txt-24-semi",
});
